import { Component } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(private ngConfig: NgSelectConfig) {
    this.ngConfig.notFoundText = 'Aucun résultat';
    this.ngConfig.typeToSearchText = 'Saisir une valeur pour lancer la recherche';
  }
}
